// import Invoice from '@/plugins/dashboard/widgets/Invoice'
import Resource from '@/plugins/sdk/Resource'
import { NUMBER, DATE, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
// import File from '@/plugins/sdk/resources/File'

export default class extends Resource {
  static name = 'invoice'

  static get fields () {
    return {
      id: new UUID(),
      invoice_created: new DATETIME(),
      invoice_date: new DATE(),
      cons_to_date: new DATE(),
      buy_rate: new NUMBER(),
      buy_fees: new NUMBER(),
      buy_fuel: new NUMBER(),
      buy_tax: new NUMBER(),
      sell_rate: new NUMBER(),
      sell_fees: new NUMBER(),
      sell_fuel: new NUMBER(),
      sell_tax: new NUMBER(),
      invoice_type: new STRING(),
      invoice_type_id: new NUMBER(),
      invoice_status: new NUMBER(),
      invoice_account_counter: new STRING(),
      invoice_file_name: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      account: new ITEM(Account)
      // pdf_file: new ITEM(File),
      // csv_file: new ITEM(File),
      // parent: new ITEM(Invoice)
    }
  }
}
